import { ICustomerAccountToPay } from '../services/hpf-transaction-service';
import { FeeCalculationValue } from './feeCalculationValue';

export class TemplateData {
	customObject: any;
	accountPayments: ICustomerAccountToPay[];
	feeValues: FeeCalculationValue[];
	isEzpay: boolean;
	merchantKey: number;

	constructor(customObject: any, merchantKey: number = null, accountPayments: ICustomerAccountToPay[] = null, feeValues: FeeCalculationValue[] = null, isEzpay: boolean = false) {
		this.customObject = customObject;
		this.accountPayments = accountPayments;
		this.feeValues = feeValues;
		this.isEzpay = isEzpay;
		this.merchantKey = merchantKey;
	}
}
